var React = require('react');

function IconStarHalfInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.3644 0V19.2694L5.16859 25.224L8.2991 15.5893L0.103333 9.6347H10.2339L13.3644 0Z","fill":"currentColor"}));
}

IconStarHalfInline.defaultProps = {"width":"14","height":"26","viewBox":"0 0 14 26","fill":"none"};

module.exports = IconStarHalfInline;

IconStarHalfInline.default = IconStarHalfInline;
